import { render, staticRenderFns } from "./TabelaResultado.vue?vue&type=template&id=e388fb6a&scoped=true"
import script from "./TabelaResultado.vue?vue&type=script&lang=js"
export * from "./TabelaResultado.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=e388fb6a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e388fb6a",
  null
  
)

export default component.exports